import React from 'react';
import { Job, Expense, User, TimeEntry, ContractorInvoice, LedgerEntry, FinancialRecord } from '../types';
import AdminFinanceView from './AdminFinanceView';
import EmployeeFinanceView from './EmployeeFinanceView';
import ContractorFinanceView from './ContractorFinanceView';

interface Props {
  jobs: Job[];
  expenses: Expense[];
  onAddExpense: (expense: Expense) => void;
  onUpdateJob: (job: Job) => void;
  user: User;
  timeEntries: TimeEntry[];
  onAddTimeEntry: (entry: TimeEntry) => void;
  onUpdateTimeEntry: (entry: TimeEntry) => void;
  contractorInvoices: ContractorInvoice[];
  onAddContractorInvoice: (invoice: ContractorInvoice) => void;
  onUpdateContractorInvoice: (invoice: ContractorInvoice) => void;
  ledgerEntries: LedgerEntry[];
  onAddLedgerEntry: (entry: LedgerEntry) => void;
  onUpdateLedgerEntry: (entry: LedgerEntry) => void;
  financialRecords?: FinancialRecord[];
  onUpdateFinancialRecord?: (record: FinancialRecord) => void;
  onDeleteFinancialRecord?: (recordId: string) => void;
}

const FinanceView: React.FC<Props> = ({ 
  jobs, 
  expenses, 
  onAddExpense, 
  onUpdateJob, 
  user, 
  timeEntries, 
  onAddTimeEntry, 
  onUpdateTimeEntry,
  contractorInvoices, 
  onAddContractorInvoice,
  onUpdateContractorInvoice,
  ledgerEntries,
  onAddLedgerEntry,
  onUpdateLedgerEntry,
  financialRecords,
  onUpdateFinancialRecord,
  onDeleteFinancialRecord
}) => {
  if (user.staffRole === 'employee') {
    return <EmployeeFinanceView user={user} timeEntries={timeEntries} onAddTimeEntry={onAddTimeEntry} onUpdateTimeEntry={onUpdateTimeEntry} expenses={expenses} onAddExpense={onAddExpense} />;
  }
  if (user.staffRole === 'contractor') {
    return <ContractorFinanceView user={user} contractorInvoices={contractorInvoices} onAddContractorInvoice={onAddContractorInvoice} onUpdateContractorInvoice={onUpdateContractorInvoice} />;
  }
  
  return <AdminFinanceView 
    jobs={jobs} 
    expenses={expenses} 
    onAddExpense={onAddExpense} 
    onUpdateJob={onUpdateJob} 
    timeEntries={timeEntries}
    onUpdateTimeEntry={onUpdateTimeEntry}
    contractorInvoices={contractorInvoices}
    onUpdateContractorInvoice={onUpdateContractorInvoice}
    ledgerEntries={ledgerEntries}
    onAddLedgerEntry={onAddLedgerEntry}
    onUpdateLedgerEntry={onUpdateLedgerEntry}
    financialRecords={financialRecords}
    onUpdateFinancialRecord={onUpdateFinancialRecord}
    onDeleteFinancialRecord={onDeleteFinancialRecord}
  />;
};

export default FinanceView;